module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.items.length) ? _c('div', {
    ref: "movable",
    staticClass: "checkboxes",
    class: {
      visible: _vm.visible, collapsable: _vm.collapsable, pinned: _vm.pinned, dragged: _vm.dragged
    },
    style: ({
      top: _vm.top,
      left: _vm.left
    }),
    on: {
      "mousedown": function($event) {
        _vm.onMouseDown($event)
      },
      "mousemove": function($event) {
        _vm.onMouseMove($event)
      }
    }
  }, [_c('div', {
    staticClass: "panel shadow"
  }, [_c('h2', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleVisible()
      }
    }
  }, [_vm._v(_vm._s(_vm.label) + "\n        "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePinned($event)
      }
    }
  }, [_vm._v("place")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible || !_vm.collapsable),
      expression: "visible || !collapsable"
    }],
    staticClass: "panel-content"
  }, _vm._l((_vm.items), function(category) {
    return _c('div', {
      key: _vm.key(category),
      class: 'md-' + _vm.type
    }, [_c('input', {
      attrs: {
        "type": _vm.type,
        "id": _vm.key(category)
      },
      domProps: {
        "value": category.hash,
        "checked": _vm.model.indexOf(category.hash) !== -1
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.updateValue($event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.key(category)
      }
    }, [_vm._v(_vm._s(category.name))])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItems && !_vm.visible),
      expression: "selectedItems && !visible"
    }],
    staticClass: "panel-content result",
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.selectedItems) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84df2f68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checkboxes.vue
// module id = 563
// module chunks = 1